import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  FormControlLabel,
  Switch,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface HordeSettingsProps {
  autoDowngrade: boolean;
  allowSlowWorkers: boolean;
  allowNSFW: boolean;
  promptFilter: boolean;
  trustedWorkers: boolean;
  karras: boolean;
  tiling: boolean;
  hiresFix: boolean;
  stripBackground: boolean;
  transparentBackground: boolean;
  onChange: (key: string, value: boolean) => void;
}

export const HordeSettings: React.FC<HordeSettingsProps> = ({
  autoDowngrade,
  allowSlowWorkers,
  allowNSFW,
  promptFilter,
  trustedWorkers,
  karras,
  tiling,
  hiresFix,
  stripBackground,
  transparentBackground,
  onChange
}) => (
  <Accordion sx={{ mb: 2 }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography>Horde Settings</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormGroup>
        <FormControlLabel
          control={<Switch checked={autoDowngrade} onChange={() => onChange('autoDowngrade', !autoDowngrade)} />}
          label="Auto Downgrade"
        />
        <FormControlLabel
          control={<Switch checked={allowSlowWorkers} onChange={() => onChange('allowSlowWorkers', !allowSlowWorkers)} />}
          label="Allow Slow Workers"
        />
        <FormControlLabel
          control={<Switch checked={allowNSFW} onChange={() => onChange('allowNSFW', !allowNSFW)} />}
          label="Allow NSFW"
        />
        <FormControlLabel
          control={<Switch checked={promptFilter} onChange={() => onChange('promptFilter', !promptFilter)} />}
          label="Prompt Filter"
        />
        <FormControlLabel
          control={<Switch checked={trustedWorkers} onChange={() => onChange('trustedWorkers', !trustedWorkers)} />}
          label="Use Trusted Workers"
        />
        <FormControlLabel
          control={<Switch checked={karras} onChange={() => onChange('karras', !karras)} />}
          label="Karras"
        />
        <FormControlLabel
          control={<Switch checked={tiling} onChange={() => onChange('tiling', !tiling)} />}
          label="Tiling"
        />
        <FormControlLabel
          control={<Switch checked={hiresFix} onChange={() => onChange('hiresFix', !hiresFix)} />}
          label="Hires Fix"
        />
        <FormControlLabel
          control={<Switch checked={stripBackground} onChange={() => onChange('stripBackground', !stripBackground)} />}
          label="Strip Background"
        />
        <FormControlLabel
          control={<Switch checked={transparentBackground} onChange={() => onChange('transparentBackground', !transparentBackground)} />}
          label="Transparent Background"
        />
      </FormGroup>
    </AccordionDetails>
  </Accordion>
);
